import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createPartnerOffer: [],
  loading: false,
  error: null,
};

const createPartnerOfferSlice = createSlice({
  name: "createPartnerOffer",
  initialState,
  reducers: {
    fetchCreatePartnerOfferRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreatePartnerOfferSuccess: (state, action) => {
      state.loading = false;
      state.createPartnerOffer = action.payload;
    },

    fetchCreatePartnerOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreatePartnerOfferRequest,
  fetchCreatePartnerOfferSuccess,
  fetchCreatePartnerOfferFailure,
} = createPartnerOfferSlice.actions;

export default createPartnerOfferSlice.reducer;
